import { authRoles } from 'app/auth';
import i18next from 'i18next';
import en from './i18n/en';
import hu from './i18n/hu';
import PiConnectionEditForm from './editform/PiConnectionEditForm';
import PiConnectionTable from './table/PiConnectionTable';

i18next.addResourceBundle('en', 'piConnection', en);
i18next.addResourceBundle('hu', 'piConnection', hu);

export default [
	{
		path: '/pi-connection/edit/:id',
		component: PiConnectionEditForm,
		auth: authRoles.piConnection
	},
	{
		path: '/pi-connection/:sessionNameParam?',
		component: PiConnectionTable,
		auth: authRoles.piConnection
	}
];
